module.exports = __webpack_public_path__ + "img/news16-0.2472f79e.png";